import React from "react";
import styled from "styled-components";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { LanguageContext } from "contexts/language.context";
import { Languages } from "constants/languages";

const HeaderContainer = styled.div`
  min-height: 96px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

const Header = () => {
  return (
    <LanguageContext.Consumer>
      {({ language, setLanguage }) => (
        <HeaderContainer>
          <div>
            <ToggleButtonGroup
              exclusive
              size="small"
              value={language}
              onChange={(event) => setLanguage(event.target.value)}
            >
              {Languages.map(({ value, text }) => (
                <ToggleButton value={value}>{text}</ToggleButton>
              ))}
            </ToggleButtonGroup>
          </div>
        </HeaderContainer>
      )}
    </LanguageContext.Consumer>
  );
};

export default Header;
